export default "/img/retailcapital.svg"